<template>
    <div class="d-flex justify-content-center align-items-center">
        <a title="صفحه قبل" v-if="intPageNumber > 1" v-on:click="changePage(-1)">
            <i class="fas fa-chevron-circle-right fa-lg text-primary mt-1"></i>
        </a>
        <span v-else>
            <i class="fas fa-chevron-circle-right fa-lg text-muted mt-1"></i>
        </span>
        <div class="mx-2" :class="(intPageNumber != intCountPage ? 'text-primary' : 'text-muted')">{{ intPageNumber }} از {{ getCountPage }}</div>
        <a title="صفحه بعد" v-if="intPageNumber < intCountPage" v-on:click="changePage(1)">
            <i class="fas fa-chevron-circle-left fa-lg text-primary mt-1"></i>
        </a>
        <span v-else>
            <i class="fas fa-chevron-circle-left fa-lg text-muted mt-1"></i>
        </span>
    </div>
</template>

<script>
export default {
    name: "PaginationSmall_" + this.Name,
    props: ["DataRepository", "Name", "CountRow"],
    watch: {
        // در لحظه تغییر در منبع اطلاعات یکبار اجرا می شود
        DataRepository: function () {
            // دریافت تعداد سطر در هر صفحه از والد
            // this.intCountRow = this.CountRow;
            // alert(this.Name + ' \ ' + this.intCountRow);
        },
    },
    data() {
        return {
            // تعداد سطرها در هر صفحه
            intCountRow: this.CountRow,
            // شماره صفحه در حال انتخاب
            intPageNumber: 1,
            // تعداد کل صفحه ها
            intCountPage: 1,
        }
    },
    created() { },
    mounted() { },
    computed: {
        // دریافت تعداد صفحات لیست
        getCountPage() {
            if (this.DataRepository != null && this.DataRepository.length > 0) {
                let intCountPageLocal = this.DataRepository.length;
                intCountPageLocal = parseInt(intCountPageLocal / this.intCountRow);
                if (this.DataRepository.length % this.intCountRow) {
                    intCountPageLocal++;
                }
                if (intCountPageLocal < this.intPageNumber) {
                    this.intPageNumber = intCountPageLocal;
                }
                this.intCountPage = parseInt(intCountPageLocal);
                // اعلام اعمال تغییرات به والد
                this.$emit("ChangePage", { countRow: this.intCountRow, pageNumber: this.intPageNumber, countPage: this.intCountPage });
                return parseInt(this.intCountPage);
            } else {
                return 1;
            }
        },
    },
    methods: {
        changePage(numPage){
            this.intPageNumber += numPage;
            if (this.intPageNumber == 0) this.intPageNumber = 1;
            if (this.intPageNumber > this.intCountPage) this.intPageNumber = this.intCountPage
        }
    },
}
</script>

<style>
.pagination .page-item .page-link:hover {
    background-color: #efff6e;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/PublicComponents/PaginationSmall.vue